/**
 * Classe que contem o editor da grid para o service time update
 * @author: Adalto Junior
 * DATE: 15/08/2013
 *
 */


Greenmile.Grid = Greenmile.Grid || {};
Greenmile.Grid.Editor = Greenmile.Grid.Editor || {};

Greenmile.Grid.Editor.TimePicker = function (args) {

    this.value = "";
    this.input = null;

    this.destroy = function () {
    };

    this.focus = function () {
    };

    this.isValueChanged = function () {

        return this.value !== this.input.value;

    };

    this.serializeValue = function () {

        var dateFormated = 0;

        if (this.input.value !== "") {
            dateFormated = new Monet.Format.SECONDS(this.input.value).convertHourToSeconds().getValue();
        }

        this.value = this.input.value;

        return dateFormated;

    };

    this.loadValue = function (item) {

        var model = item.model.attributes;
        var field = args.column.field;
        var value = item[args.column.field];

        if (field === "sugFixTimeSecs") {

            if (typeof model.userFixTimeSecs !== "undefined" && model.userFixTimeSecs !== "") {
                value = model.userFixTimeSecs;
            }

        } else if (field === "sugVarTimeSecs" && typeof model.userVarTimeSecs !== "undefined" && model.userVarTimeSecs !== "") {
            value = model.userVarTimeSecs;
        }

        this.input.value = new Monet.Format.SECONDS(value).convertSecondsToHourMinutesSeconds().getValue();

    };

    this.applyValue = function (item, state) {

        var model = item.model;
        var field = args.column.field;

        item[field] = state;

        if (field === "sugFixTimeSecs") {

            model.set("userFixTimeSecs", state);

        } else if (field === "sugVarTimeSecs") {

            model.set("userVarTimeSecs", state);

        }

    };

    this.validate = function () {

        var obj = { valid: true, msg: "" };

        return obj;
    };

    this.init = function () {

        const title = Monet.I18n.getResourcesByKey("Greenmile.TimePicker.ServiceTimeUpdates.Title");
        const timeFormat = new Monet.Date.GeneralFunctions().getAbsoluteTimeFormatWithSeconds();
        
        const callback = function () {
            $('.ui-datepicker-current').css('display', 'none');
        };
        
        this.input = document.createElement("input");
        this.input.setAttribute("type", "text");
        this.input.style.width = "100%";


        $(this.input).timepicker("destroy");
        $(this.input).timepicker({
            hourGrid: 4,
            minuteGrid: 10,
            secondGrid: 10,
            showSecond: true,
            timeFormat,
            timeOnlyTitle: title,
            beforeShow: () => {
                $('main').append($('#ui-datepicker-div'));
            }
        });

        if (args.container) {
          args.container.appendChild(this.input);
        }

        this.input.removeEventListener("focus", callback);
        this.input.addEventListener("focus", callback);
        this.input.focus();


    };

    this.init();
};